import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useApp } from '../../context/AppContext.jsx';
import './BottomNav.css';

const NAV = [
  { to:'/',             label:'Home',     emoji:'🏠' },
  { to:'/services',     label:'Services', emoji:'🛠️' },
  { to:'/bookings',     label:'Bookings', emoji:'📋' },
  { to:'/notifications',label:'Alerts',   emoji:'🔔', badge:true },
  { to:'/profile',      label:'Profile',  emoji:'👤' },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  const { unreadCount } = useApp();

  return (
    <nav className="bnav" aria-label="Main navigation">
      {NAV.map(({ to, label, emoji, badge }) => {
        const active = to === '/' ? pathname === '/' : pathname.startsWith(to);
        return (
          <NavLink key={to} to={to} className={`bnav__item ${active ? 'bnav__item--on' : ''}`} aria-label={label}>
            <div className="bnav__box">
              {active && <span className="bnav__bubble" />}
              <span className="bnav__emoji" role="img" aria-hidden="true">{emoji}</span>
              {badge && unreadCount > 0 && <span className="bnav__badge" aria-label={`${unreadCount} unread`}>{unreadCount > 9 ? '9+' : unreadCount}</span>}
            </div>
            <span className="bnav__label">{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
